import { useRef, useState } from "react";
import { ClickAwayListener, MenuList, MenuItem as MaterialMenuItem, Popper, Paper, Grid } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./styles";
import { useLocation, useNavigate } from "react-router-dom";
import useStyles from "@hooks/useStyle";
import { AppMenuInterface, MenuInterface } from "@mv-types";
import { Typography } from "@mv-components/index";

const MenuItem = (props: { subMenu: MenuInterface }) => {
	const { subMenu: menu } = props;
	const { classes } = useStyles(styles) as any;
	const menuIconRef = useRef(null);
	const [subMenuOpen, setSubMenuOpen] = useState(false);

	const navigate = useNavigate();
	const location = useLocation();

	const handleMenuSelect = (route: AppMenuInterface) => {
		setSubMenuOpen(false);
		route.path && navigate(route.path);
	};
	const handleMenuClose = () => {
		setSubMenuOpen(false);
	};
	const handleMouseEnter = (e: any) => {
		e.stopPropagation();
		setSubMenuOpen(true);
	};
	const handleMouseLeave = (e: any) => {
		e.stopPropagation();
		setSubMenuOpen(false);
	};

	const isMenuItemActive =
		location.pathname === menu.path || menu.subMenus?.map((subMenu) => subMenu.path).includes(location.pathname);

	return (
		<Grid onMouseLeave={handleMouseLeave}>
			<Grid
				id={menu.menuLabel}
				ref={menuIconRef}
				onMouseEnter={handleMouseEnter}
				className={isMenuItemActive ? classes.primaryColor : classes.colorDarkGrey}
				onClick={(e: any) => {
					menu.path ? navigate(menu.path) : handleMouseEnter(e);
				}}
				container
			>
				<Typography className={isMenuItemActive ? classes.primaryColor : classes.colorDarkGrey}>
					{menu.menuLabel}
				</Typography>
				{menu.subMenus && <ExpandMoreIcon className={classes.downIcon} />}
			</Grid>
			<ClickAwayListener onClickAway={handleMenuClose}>
				<Popper
					open={subMenuOpen}
					anchorEl={menuIconRef.current}
					placement="bottom-start"
					style={{ zIndex: 2 }}
					disablePortal
				>
					<Paper>
						<MenuList>
							{menu.subMenus?.map((currentSubMenu) => {
								return (
									<MaterialMenuItem
										className={classes.subMenuItem}
										key={currentSubMenu.menuLabel}
										onClick={() => handleMenuSelect(currentSubMenu)}
									>
										<Typography
											className={
												location.pathname === currentSubMenu.path
													? classes.primaryColor
													: classes.colorDarkGrey
											}
										>
											{currentSubMenu.menuLabel}
										</Typography>
									</MaterialMenuItem>
								);
							})}
						</MenuList>
					</Paper>
				</Popper>
			</ClickAwayListener>
		</Grid>
	);
};

export default MenuItem;
